// apps/vendor/src/App.tsx
import { RouterProvider } from "react-router-dom";
import { ErrorBoundary } from "@yogo/ui";
import { router } from "./router";
import ServerErrorPage from "./pages/error/ServerErrorPage";

export default function App() {
  return (
    <ErrorBoundary fallback={<ServerErrorPage />}>
      <RouterProvider router={router} />
    </ErrorBoundary>
  );
}

// Day 59 complete
